HTMLElement.prototype.getOffset = function (stopSelectorElement) {
  var offsetParent = this.offsetParent;
  var top = this.offsetTop,
    left = this.offsetLeft,
    scrollLeft = 0,
    scrollTop = 0;
  while (offsetParent) {
    top += offsetParent.offsetTop;
    scrollTop += offsetParent.scrollTop;
    scrollLeft += offsetParent.scrollLeft;
    left += offsetParent.offsetLeft;
    offsetParent = offsetParent.offsetParent;
    if (stopSelectorElement && offsetParent == stopSelectorElement) break;
  }
  return {
    top: top,
    left: left,
    width: this.offsetWidth,
    height: this.offsetHeight,
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
// 日期对象扩展
Date.prototype.format = function (format) {
  var formatData = format;
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "h+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    "S": this.getMilliseconds() //millisecond
  };
  if (/(y+)/.test(formatData)) {
    formatData = formatData.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(formatData)) {
      formatData = formatData.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return formatData;
};

// 计算视频时长
Date.prototype.timeToMinute = function (times) {
  var t;
  if (times > -1) {
    var hour = Math.floor(times / 3600);
    var min = Math.floor(times / 60) % 60;
    var sec = times % 60;
    if (hour < 10) {
      t = '0' + hour + ":";
    } else {
      t = hour + ":";
    }

    if (min < 10) { t += "0"; }
    t += min + ":";
    if (sec < 10) { t += "0"; }
    t += sec.toFixed(0);
  }
  return t;
}
//获取中文长度，中文占用两个字符
// String.prototype.charLength = function () {
//   var len = 0;
//   for (var i = 0; i < this.length; i++) {
//     if (this.substr(i, 1).match(/[^\x00-\xff]/ig)) {
//       len += 2;
//     } else {
//       len += 1;
//     }
//   }
//   return len;
// }
//获取中文长度，中文占用两个字符
String.prototype.trim = function () {
  return this.replace(/(^\s*)|(\s*$)/g, "");
}
//截取文本，中文占用两个字符
// String.prototype.subchar = function (_length, _suffix) {
//   var value = this, len = 0; //字符长度，汉字占有2个字节，英文占有1个字节
//   var suffix = (_suffix ? _suffix : "");
//   for (var i = 0; i < value.length; i++) {
//     if (value.substr(i, 1).match(/[^\x00-\xff]/ig)) {
//       len += 2;
//     } else {
//       len += 1;
//     }
//     if (len >= _length) {
//       return value.substr(0, i + 1 - (len > _length ? 1 : 0)) + suffix;
//     }
//   }
//   return value;
// }
// 字符串去空格
String.prototype.removeSpace = function () {
  var str = this;
  return str.replace(/\s*/g, "");
}
// 删除数组的某一项（只针对一维数组）
Array.prototype.remove = function (val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
/**
* 去除数组重复数据
*/
Array.prototype.removeRepetition = function () {
  for (let index = this.length - 1; index >= 0; index--) {
    let item = this[index];
    let dataIndex = this.indexOf(item);
    if (dataIndex !== index && dataIndex >= 0) this.splice(index, 1);
  }
};
export default {};
